<template>
  <div class="dict-manage">
    <page-header title="字典管理" icon="el-icon-notebook-1"></page-header>
    
    <!-- 搜索区域 -->
    <div class="search-area">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="字典名称">
          <el-input v-model="searchForm.dictName" placeholder="请输入字典名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="字典类型">
          <el-input v-model="searchForm.dictType" placeholder="请输入字典类型" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="字典状态" clearable>
            <el-option label="正常" value="1"></el-option>
            <el-option label="停用" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch" style="margin-left: 20px;">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 操作按钮区 -->
    <div class="table-operations">
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
     
    </div>

    <!-- 表格区域 -->
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
      v-loading="tableLoading"
      element-loading-text="加载中..."
      >
      
     
      <el-table-column prop="dictName" label="字典名称" align="center"></el-table-column>
      <el-table-column prop="dictType" label="字典类型" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleViewDictItems(scope.row)">
            {{ scope.row.dictType }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === '1' ? 'success' : 'info'">
            {{ scope.row.status === '1' ? '正常' : '停用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180" align="center"></el-table-column>
      <el-table-column label="操作" width="180" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">修改</el-button>
          <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
    </div>


   

    <!-- 统一的新增/修改对话框 -->
    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="dialogVisible" 
      width="500px"
      append-to-body>
      <el-form 
        ref="form" 
        :model="form" 
        :rules="rules" 
        label-width="80px">
        <el-form-item label="字典名称" prop="dictName">
          <el-input v-model="form.dictName" placeholder="请输入字典名称"></el-input>
        </el-form-item>
        <el-form-item label="字典类型" prop="dictType">
          <el-input v-model="form.dictType" placeholder="请输入字典类型"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio label="1">正常</el-radio>
            <el-radio label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input 
            type="textarea" 
            v-model="form.remark" 
            placeholder="请输入备注"
            :rows="4">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import PageHeader from '@/components/common/PageHeader.vue'

export default {
  name: 'DictManage',
  components: {
    PageHeader
  },
  data() {
    return {
      tableLoading: false,
      // 搜索表单
      searchForm: {
        dictName: '',
        dictType: '',
        status: ''
      },
      // 表格数据
      tableData: [],
      // 分页信息
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 选中的行
      selectedRows: [],
      // 字典数据对话框
      dictItemsVisible: false,
      currentDict: {},
      dictItemsData: [],
      itemPagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 对话框显示控制
      dialogVisible: false,
      dialogTitle: '',
      // 表单数据
      form: {
        dictId: '',
        dictName: '',
        dictType: '',
        status: '1',
        remark: ''
      },
      // 表单验证规则
      rules: {
        dictName: [
          { required: true, message: '请输入字典名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        dictType: [
          { required: true, message: '请输入字典类型', trigger: 'blur' },
          { pattern: /^[A-Z,a-z_]+$/, message: '只能包含大写字母、小写字母、数字和下划线', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.fetchDictList()
  },
  methods: {
    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1
      this.fetchDictList()
    },
    // 重置搜索
    resetSearch() {
      this.searchForm = {
        dictName: '',
        dictType: '',
        status: ''
      }
      this.handleSearch()
    },
    // 获取字典列表
    async fetchDictList() {
      try {
        const res = await request({
          url: '/api/v1/dict/list',
          method: 'POST',
          data: {
            name: this.searchForm.dictName,
            page: this.pagination.currentPage,
            size: this.pagination.pageSize
          }
        })
        
        if (res && (res.status === 1 || res.status === true) && res.data) {
          const list = Array.isArray(res.data.list) ? res.data.list : []
          
          this.tableData = list.map(item => ({
            dictId: item.dictId,
            dictName: item.dictName,
            dictType: item.dictType,
            status: item.status?.toString() || '0',
            createTime: item.createdAt,
            remark: item.remark || ''
          }))
          
          this.pagination.total = res.data.total || 0
          
          if (this.tableData.length === 0 && this.pagination.currentPage > 1) {
            this.pagination.currentPage--
            await this.fetchDictList()
          }
        } else {
          throw new Error(res?.msg || '获取列表失败')
        }
      } catch (error) {
        console.error('获取字典列表错误:', error)
        this.$message.error(error?.message || '获取字典列表失败')
      }
    },
    // 新增按钮点击
    handleAdd() {
      this.dialogTitle = '添加字典类型'
      this.form = {
        dictId: '',
        dictName: '',
        dictType: '',
        status: '1',
        remark: ''
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form?.resetFields()
      })
    },
    // 修改按钮点击
    handleEdit(row) {
      this.dialogTitle = '修改字典类型'
      this.form = {
        dictId: row.dictId,
        dictName: row.dictName,
        dictType: row.dictType,
        status: row.status,
        remark: row.remark
      }
      this.dialogVisible = true
    },
    // 统一的提交方法
    async submitForm() {
      try {
        await this.$refs.form.validate()
        const res = await request({
          url: '/api/v1/dict/save',
          method: 'POST',
          data: {
            dictId: this.form.dictId,
            dictName: this.form.dictName,
            dictType: this.form.dictType,
            status: parseInt(this.form.status),
            remark: this.form.remark
          }
        })

        if (res.status === 1) {
          this.$message.success(this.form.dictId ? '修改成功' : '新增成功')
          this.dialogVisible = false
          this.fetchDictList()
        }
      } catch (error) {
        console.error('保存字典错误:', error)
        this.$message.error(error.message || '保存失败')
      }
    },
    // 删除字典类型
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该字典类型?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const res = await request({
          url: '/api/v1/dict/delete',
          method: 'POST',
          data: {
            dictId: row.dictId
          }
        })

        if (res && (res.status === 1 || res.status === true)) {
          this.$message.success(res.msg || '删除成功')
          this.pagination.currentPage = 1
          await this.fetchDictList()
        } else {
          throw new Error(res?.msg || '删除失败')
        }
      } catch (error) {
        if (error?.message === 'cancel' || error === 'cancel') {
          return
        }
        console.error('删除字典错误:', error)
        this.$message.error(error?.message || '删除失败，请重试')
      }
    },
    // 获取字典数据列表
    async fetchDictItems(dictId) {
      this.tableLoading = true
      this.dictItemsData = []
      this.total= 0
      try {
        const res = await request({
          url: `/api/v1/sys-dict/${dictId}/items`,
          method: 'POST'
        })
        
        if (res.status === 1) {
          this.dictItemsData = res.data.map(item => ({
            dictCode: item.item_id,
            dictLabel: item.item_label,
            dictValue: item.item_value,
            dictSort: item.sort,
            status: item.status.toString(),
            createTime: item.created_at,
            remark: item.remark || ''
          }))
        }
      } catch (error) {
        console.error('获取字典数据错误:', error)
        this.$message.error('获取字典数据失败')
      }finally{
        this.tableLoading = false
      }
      
    },
    // 保存字典数据
    async submitDictItem(dictId, data) {
      try {
        const res = await request({
          url: `/api/v1/sys-dict/${dictId}/item/save`,
          method: 'POST',
          data: {
            dictItemId: data.dictItemId,
            dictId: dictId,
            dictItemName: data.dictItemName,
            dictItemValue: data.dictItemValue,
            dictItemStatus: parseInt(data.status),
            parentId: data.parentId || ''
          }
        })

        if (res.status === 1) {
          this.$message.success('保存成功')
          this.fetchDictItems(dictId)
        }
      } catch (error) {
        console.error('保存字典数据错误:', error)
        this.$message.error(error.message || '保存失败')
      }
    },
    // 删除字典数据
    async handleDeleteItem(row) {
      try {
        await this.$confirm('确认删除该字典数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const res = await request({
          url: '/api/v1/sys-dict/dict/item/delete',
          method: 'POST',
          data: {
            dictItemId: row.dictCode
          }
        })

        if (res.status === 1) {
          this.$message.success('删除成功')
          this.fetchDictItems(this.currentDict.dictId)
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除字典数据错误:', error)
          this.$message.error(error.message || '删除失败')
        }
      }
    },
    // 选择变化
    handleSelectionChange(val) {
      this.selectedRows = val
    },
    // 导出
    handleExport() {
      // TODO: 实现导出逻辑
    },
    // 分页大小变化
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.fetchDictList()
    },
    // 当前页变化
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.fetchDictList()
    },
    // 查看字典数据
    async handleViewDictItems(row) {
      // 使用路由导航到字典数据页面，携带字典ID和字典名称
      this.$router.push({
        name: 'DictData',
        params: {
          dictId: row.dictId,
          dictType: row.dictType,
          dictName: row.dictName
        }
      })
    },
    // // 新增字典数据
    // handleAddItem() {
    //   // TODO: 实现新增字典数据逻辑
    // },
    // // 修改字典数据
    // handleModifyItem() {
    //   if (this.selectedRows.length !== 1) {
    //     this.$message.warning('请选择一条记录进行修改')
    //     return
    //   }
    //   this.handleEditItem(this.selectedRows[0])
    // },
    // // 编辑字典数据
    // handleEditItem(row) {
    //   // 实现编辑字典数据逻辑
    //   this.editItemForm = {
    //     dictItemId: row.dictId,
    //     dictItemName: row.dictLabel,
    //     dictItemValue: row.dictValue,
    //     status: row.status,
    //     remark: row.remark
    //   }
    //   this.editItemDialogVisible = true
    // },
    // // 字典数据分页大小变化
    // handleItemSizeChange(val) {
    //   this.itemPagination.pageSize = val
    // },
    // // 字典数据当前页变化
    // handleItemCurrentChange(val) {
    //   this.itemPagination.currentPage = val
    // }
  }
}
</script>

<style lang="scss" scoped>
.dict-manage {
  padding: 20px;

  .search-area {
    background: #fff;
    padding: 20px;
    margin-bottom: 20px;
    border-radius: 4px;
  }

  .table-operations {
    margin-bottom: 16px;
    
    .el-button {
      margin-right: 8px;
    }
  }

  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }

  /* 修改字典类型列的按钮样式 */
  :deep(.el-button--text) {
    padding: 0;
    height: auto;
    
    &:hover {
      color: #409EFF;
      text-decoration: underline;
    }
  }

  // 表格样式
  .el-table {
    margin: 15px 0;
    
    // 调整表头样式
    ::v-deep .el-table__header-wrapper {
      th {
        background-color: #f5f7fa;
        color: #606266;
        font-weight: 600;
        text-align: center;
      }
    }
    
    // 调整单元格样式
    ::v-deep .el-table__body-wrapper {
      td {
        padding: 12px 0;
      }
    }
    
    // 调整操作按钮间距
    .el-button--text {
      padding: 0 8px;
    }
  }
}

.dict-items-container {
  .table-operations {
    margin-bottom: 16px;
    
    .el-button {
      margin-right: 8px;
    }
  }

  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }
}
</style> 